module.exports = __webpack_public_path__ + "img/142.ca42b000.jpg";